import { createFileRoute } from "@tanstack/react-router";
import { PrayerHome } from "@/components/prayer/PrayerHome";

export const Route = createFileRoute("/jadwal-imsak/")({
  head: () => ({
    meta: [
      { title: "Jadwal Imsakiyah Hari Ini Seluruh Indonesia - hari.co.id" },
      { name: "description", content: "Jadwal imsakiyah lengkap (Imsak, Subuh, Maghrib, Isya) untuk seluruh kota di Indonesia. Akurat untuk sahur dan berbuka puasa." },
      { property: "og:title", content: "Jadwal Imsakiyah Indonesia" },
      { property: "og:description", content: "Jadwal imsak, sahur, dan berbuka untuk setiap kota di Indonesia." },
      { property: "og:url", content: "https://hari.co.id/jadwal-imsak/" },
      { property: "og:image", content: "https://hari.co.id/og-jadwal-imsak.svg" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: "https://hari.co.id/og-jadwal-imsak.svg" },
      { name: "robots", content: "index, follow, max-image-preview:large" },
    ],
    links: [{ rel: "canonical", href: "https://hari.co.id/jadwal-imsak/" }],
  }),
  component: () => <PrayerHome variant="imsak" />,
});